import { render } from "./DocumentViewer.vue?vue&type=template&id=a00d073c&ts=true"
import script from "./DocumentViewer.vue?vue&type=script&lang=ts"
export * from "./DocumentViewer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/common/infrastructure/componentes/base/common/visor/DocumentViewer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a00d073c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a00d073c', __exports__)) {
    api.reload('a00d073c', __exports__)
  }
  
  module.hot.accept("./DocumentViewer.vue?vue&type=template&id=a00d073c&ts=true", () => {
    api.rerender('a00d073c', render)
  })

}


export default __exports__